import React from 'react';

type Props = {
    children: React.ReactNode;
};

type State = {
    hasError: boolean;
};

/**
 * Catches render errors (e.g. "removeChild" when Chrome Translator modifies the DOM)
 * and shows a friendly recovery message instead of the generic "Unexpected Application Error".
 * Fallback uses plain DOM only so it cannot throw (no MUI/context dependency).
 */
export class ErrorBoundary extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(): State {
        return { hasError: true };
    }

    render() {
        if (this.state.hasError) {
            return (
                <div
                    role="alert"
                    style={{
                        padding: 16,
                        margin: 16,
                        backgroundColor: '#fff3e0',
                        border: '1px solid #ff9800',
                        borderRadius: 4,
                        color: '#e65100',
                    }}
                >
                    <p style={{ margin: '0 0 12px 0', fontSize: 14 }}>
                        This section had an error. This can happen when using browser translation (e.g. Chrome Translate) on this page.
                        Reload the page or turn off translation for this site, then try again.
                    </p>
                    <button
                        type="button"
                        onClick={() => window.location.reload()}
                        style={{
                            padding: '6px 16px',
                            fontSize: 14,
                            cursor: 'pointer',
                            backgroundColor: '#ff9800',
                            color: '#fff',
                            border: 'none',
                            borderRadius: 4,
                        }}
                    >
                        Reload page
                    </button>
                </div>
            );
        }
        return this.props.children ?? null;
    }
}

export default ErrorBoundary;
